import Home from './Home';

export default {
  path: '/',
  component: Home,
  name: 'home',
};